import rimg from './scripts/rimgShopify';

// Global instance
rimg.init();

export default class LazyImg extends Core.Component {
  constructor(el, context) {
    super(el, context);

    rimg.watch(this.el);
  }

  unload() {
    rimg.unwatch(this.el);
  }
}
